// Categories
export const TRACK_CATEGORY_HOME = 'Home'
export const TRACK_CATEGORY_ABOUT = 'About Us'
export const TRACK_CATEGORY_SELLER_FINANCE = 'Seller Finance'
export const TRACK_CATEGORY_BUYER_FINANCE = 'Buyer Finance'
export const TRACK_CATEGORY_CAREERS = 'Careers'
export const TRACK_CATEGORY_CONTACT = 'Contact Us'
export const TRACK_CATEGORY_SIGN_UP = 'Sign Up'
export const TRACK_CATEGORY_IMPRINT = 'Imprint'
export const TRACK_CATEGORY_PRIVACY_STATEMENT = 'Privacy Statement'
export const TRACK_CATEGORY_TERMS_OF_USE = 'Terms of Use'

// Actions
export const TRACK_ACTION_NAVIGATE = 'Navigate'
export const TRACK_ACTION_FORM = 'Form'
export const TRACK_ACTION_OUTBOUND_LINK = 'Outbound Link'
